import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'

import RouteViewComponent from '../layouts/RouterBypass.vue'
import { useAuthStore } from '../stores/auth';
import pinia from "../stores/store";
import { useACLStore } from "../stores/acl";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'companies' },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'companies' },
    children: [
      {
        name: 'settings',
        path: 'settings',
        component: () => import('../pages/settings/Settings.vue'),
      },
      {
        name: 'preferences',
        path: 'preferences',
        component: () => import('../pages/preferences/Preferences.vue'),
      },
      {
        name: 'companies',
        path: 'companies',
        component: () => import('../pages/companies/CompaniesPage.vue'),
      },
      {
        name: 'firmwares',
        path: 'firmwares',
        component: () => import('../pages/firmwares/FirmwaresPage.vue'),
      },
      {
        name: 'kkt',
        path: 'kkt',
        component: () => import('../pages/kkt/KktPage.vue'),
      },
      {
        name: 'licenses',
        path: 'licenses',
        component: () => import('../pages/licenses/LicensePage.vue'),
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})
router.beforeEach((to, from, next) => {
  const store = useAuthStore(pinia);
  let isAuthenticated = localStorage.getItem('token') != null
  if (to.path === "/auth/login") {
    if (isAuthenticated) store.logout()
    next();
  }else if (!isAuthenticated) next("/auth/login");
  else next();
});
export default router
